import { render } from "./BudgetStepTargetRomi.vue?vue&type=template&id=0a6fc20a"
import script from "./BudgetStepTargetRomi.vue?vue&type=script&lang=js"
export * from "./BudgetStepTargetRomi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__